import { Component, OnInit } from '@angular/core';
import { LoginService } from '../services/login.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  constructor(public ls : LoginService,private router: Router) { 
    if(!ls.isAuthenticated)
    {
      this.router.navigate(['/']);
    }
   
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/header/header.component.ts